export default `
    <div
        id="#: data.id #_cid"
        class="pane-field #: data.bsc #"
    >
        <div class="row">
            <span id="#: data.id #_titleSpan" class="text-align-right text-align-centerv pane-field-label col-xs-5" id="#: data.id #_labelSpan">
                <span 
                    id="#: data.id #_title"
                    disabled
                >#: data.title #</span>
                <input 
                    hidden
                    class="pane-field-input"
                    style="margin-top: 1px; width: 100%;"
                    type="text"
                    id="#: data.id #_titleTB"
                >
            </span>
            <span class="col-xs-5 no-pad"  id="#: data.id #_linkSpan">
                <a
                    id="#: data.id #_url"
                    class="link pointer col-xs-7 eurl-anchor bind-value #: data.classes #"
                >
                    <span
                        id="#: data.id #_innerurl"
                        data-label-for-id="#: data.id #_url"
                        class="text-align-left bind-value #: data.classes #"
                        data-bind="#: data.bindValue #"
                    >
                </a>  
                # if (data.disabled != true && data.readOnly != true) { #
                    <i
                        class="align-left pane-body-icon edit"
                        style="cursor: pointer;"
                        id="#: data.id #_pencilIcon"
                    ></i>
                # } #
                <input 
                    hidden
                    class="pane-field-input"
                    style="width: 100%;"
                    type="text"
                    id="#: data.id #_urlTB" 
                >
                <span 
                    hidden
                    class="eurl-cf"
                    id="#: data.id #_CF"
                    title="This is a custom field"
                >C</span>
            </span>
            <span class="no-pad col-xs-2" id="#: data.id #_CheckCancel" style="padding-left: 5px;" hidden>
                <a
                    class="pane-body-icon-container link pointer hover-image-container"
                    id="#: data.id #_checkIcon"
                    title="#: data.checkTitle #"
                >
                    <span class="pane-body-icon check"></span>
                </a>
                <a
                    class="pane-body-icon-container link pointer hover-image-container"
                    id="#: data.id #_cancelIcon"
                    title="#: data.cancelTitle #"
                >
                    <span class="pane-body-icon cancel"></span>
                </a>
                <span
                    hidden
                    id="#: data.id #_bind"
                    data-label-for-id="#: data.id #_urlTB"
                    class="#: data.classes #"
                    data-bind="#: data.bindValue #"
                ></span>
            </span>
        </div>
    </div>
`;
